// extracted by mini-css-extract-plugin
export default {"buttons":"DeleteVariationModal_buttons__5n0jO","errorMessage":"DeleteVariationModal_errorMessage__1nKjY"};